import { useEffect, useMemo } from "react";

import { Poller } from "src/organization/pages/project/environment/metrics/utils/polling/poller";
import { MetricsPollType } from "src/organization/pages/project/environment/metrics/utils/polling/type";

import { ServerCachesMetricsResponseType } from "../experiments/ServerCachesOverview/types";
import { getFromTo } from "../experiments/ServerCachesOverview/utils";

import useObservabilityPipelineHttpClient from "./useObservabilityPipelineHttpClient";

const useServerCachesMetricsPoll = ({
  timeframe,
  onChange,
  onError,
  onLoadingChange,
  interval = 30
}: MetricsPollType<ServerCachesMetricsResponseType>) => {
  const client = useObservabilityPipelineHttpClient();
  const clientKey = client?.getKey() || null;

  const poller = useMemo(
    () => new Poller({ onChange, onError }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(() => {
    async function fetchServerCache() {
      if (client === null) {
        return Promise.reject("Null value");
      }

      try {
        onLoadingChange?.(true);
        const response = await client.getServerCachesOverview(
          getFromTo(timeframe).from,
          getFromTo(timeframe).to,
          "wt",
          1,
          ["web"]
        );
        return response;
      } catch (err) {
        console.error(err); // eslint-disable-line no-console
      } finally {
        onLoadingChange?.(false);
      }
    }

    timeframe.id
      ? poller.startPolling(fetchServerCache, interval)
      : poller.pollOnce(fetchServerCache);
  }, [
    clientKey,
    client,
    timeframe,
    interval,
    poller,
    onChange,
    onLoadingChange
  ]);

  useEffect(() => {
    return () => poller.stopPolling();
  }, [poller]);
  return poller;
};

export default useServerCachesMetricsPoll;
